/*
 * Gaming Arcade Frontend
 * Copyright (C) 2022, Zelta Tech (https://zeltatech.com)
 */
import Error1 from "../../component/Error/Error1";
import { useContext } from "react";
import errorImg from "../../component/Error/images/error-img3.png";
import NumberGameScreen from "../Playgame/NumberGameScreen";
import { PlayerMatchLogic } from "./PlayerMatchLogic";
import { useAuthContext } from "../../AuthContext";
// import { PaymentValidation } from "../../component/Context/noteContext";
import { GamePopupContext } from "../../component/Context/GamePopupContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Match = () => {
  const navigate = useNavigate();
  const {
    paymentStarted,

    playGame,

    location,
  } = PlayerMatchLogic();
  const { dispatchPopUp, gameState } = useContext(GamePopupContext);
  const { setErrorState } = useAuthContext();
  useEffect(() => {
    return function () {
      dispatchPopUp({ name: "PAYMENT", type: "open", message: "" });
    };
  }, []);
  if (paymentStarted) {
    return (
      <Error1
        close={() => {
          setErrorState(false);
          // dispatchPopUp({ type: "close" });
        }}
        text={gameState.payment_message || "Transaction in progress..."}
        errImage={errorImg}
        backImg="error-back"
        screen="game-match"
      />
    );
  }
  if (playGame === true) {
    return (
      <NumberGameScreen
        gameValue={location.state.id}
        gameName={location.state.name}
      />
    );
  } else {
    return (
      <>
        <Error1
          close={() => {
            setErrorState(false);
            // dispatchPopUp({ type: "close" });
          }}
          text="Loading..."
          errImage={errorImg}
          backImg="error-back"
          screen="game-match"
        />
      </>
    );
  }
};

export default Match;
